<template>
    <div class="home">
        <b-img src="images/bild_vilsa_t.jpg" fluid />
        <span v-html="$t('presentation.costmanagement')" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'kostenmanagement',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>
